<wzb-header #wzbHeader *ngIf="(showWzbHeader$ | async) === true" class="wzb-header" [maxWidth]="80">
  <mat-icon headerLogo svgIcon="logo-wizbii-money" class="logo--fibii"></mat-icon>

  <a
    headerLink
    [routerLink]="['/', HelpsRoutingEnum.Listing]"
    (click)="trackEvent('Home Navigation', 'Click Toutes les aides')"
    i18n
  >
    Toutes les aides
  </a>

  <button *ngIf="(isClient$ | async) === true" headerLink (click)="openDialog()" i18n>Contactez-nous</button>
  <a
    *ngIf="(isClient$ | async) === false && (isMobile$ | async) === true"
    extraMobileAction
    class="extra-mobile-action"
    [routerLink]="['/', FeaturesRoutingEnum.Faq]"
    i18n
    >FAQ</a
  >
  <a
    *ngIf="(isClient$ | async) === false && (isMobile$ | async) === false"
    headerLink
    [routerLink]="['/', FeaturesRoutingEnum.Faq]"
    i18n
    >FAQ</a
  >

  <a headerLink [routerLink]="['/', FeaturesRoutingEnum.Advices]" i18n> Conseils </a>

  <a
    *ngIf="(isLogged$ | async) === true && isHomeRoute && (hasUserBeganForm$ | async)"
    headerAction
    wzbButton
    class="header_action--spaced"
    [routerLink]="['/', FeaturesRoutingEnum.Dashboard]"
    i18n
  >
    Accéder à mes aides
  </a>

  <a
    *ngIf="(isLogged$ | async) === true && isDashboardRoute && (hasUserBeganForm$ | async)"
    headerAction
    wzbButton
    class="header_action--spaced wzb-btn--outline"
    [routerLink]="['/', FeaturesRoutingEnum.HelpForm, HelpFormRoutingEnum.Summary]"
    (click)="trackEvent('Dashboard', 'Click Update Info Header Money')"
    i18n
  >
    Mettre à jour mes informations
  </a>

  <a
    *ngIf="(isLogged$ | async) === true && isDashboardRoute && (hasUserBeganForm$ | async)"
    headerAction
    wzbButton
    (click)="resetForm()"
    class="header_action--spaced header_action--blue"
    [routerLink]="['/', FeaturesRoutingEnum.HelpForm]"
    i18n
    [class.wzb-btn--disabled]="(processingDataClear$ | async) === true"
  >
    Recommencer ma simulation
  </a>

  <button
    *ngIf="(isLogged$ | async) === true; else notLogged"
    [class.header_action--hidden]="isDashboardRoute"
    headerAction
    wzbButton
    class="wzb-btn--outline"
    (click)="doLogout()"
    i18n
  >
    Me déconnecter
  </button>

  <button
    *ngIf="isDashboardRoute && (isClient$ | async) === true"
    wzbButton
    extraMobileAction
    class="contact-btn"
    (click)="openDialog()"
  >
    <mat-icon class="contact-btn--icon" svgIcon="contact"></mat-icon>
    Nous contacter
  </button>
</wzb-header>

<div class="content">
  <router-outlet></router-outlet>
</div>

<wiz-footer
  class="footer"
  [class.footer--helps-list]="isHelpsRoute"
  *ngIf="(showWzbFooter$ | async) === true"
  [appId]="appId"
  [apiDomain]="apiDomain"
  [contactEmailKey]="contactEmailKey"
  [currentLocale]="locale"
>
  <span slot="wzbFooterListInside" class="usefull-links">
    <li>
      <a [routerLink]="['/', FeaturesRoutingEnum.Cpu]" (click)="trackEvent('Footer', 'Click CPU')" i18n>CPU</a>
    </li>

    <li>
      <a
        [href]="(version$ | async) === AbTestVersions.B ? linkPdfCgv : linkLegalityCgv"
        target="_blank"
        (click)="trackEvent('Footer', 'Click CPU')"
        i18n
        >CGV</a
      >
    </li>

    <li>
      <a [routerLink]="['/', HelpsRoutingEnum.Listing]" (click)="trackEvent('Footer', 'Click Toutes les aides')" i18n
        >Toutes les aides</a
      >
    </li>
    <li>
      <a [routerLink]="['/', FeaturesRoutingEnum.Faq]" (click)="trackEvent('Footer', 'Click FAQ')" i18n>FAQ</a>
    </li>
  </span>
</wiz-footer>

<ng-template #notLogged>
  <ng-container *ngIf="(wzbHeader?.isSticky$ | async) === true">
    <button
      wzbButton
      headerAction
      class="button--sign-in"
      (click)="navigateAccount(accountSignin, 'Click Signin')"
      i18n
    >
      Se connecter
    </button>
    <button
      wzbButton
      headerAction
      class="button--sign-up"
      (click)="navigateAccount(accountSignup, 'Click Signup')"
      i18n
    >
      Créer un compte
    </button>
  </ng-container>
</ng-template>
